require('./commons-import');
 import {FractionComponent, OperationComponent, LongMultiplication, BoxMultiplication} from 'base-exercise';
 import GoogleAutoAd from '@i/commons/GoogleAutoAd';
 import LessonSummary from '@/components/lessonSummary/lessonSummary.vue';

 const lessonCourse = new Vue({
    el: "#lesson-introduction",
    components: {OperationComponent, fraction: FractionComponent, FractionComponent, GoogleAutoAd, LessonSummary, LongMultiplication, BoxMultiplication},
    data: {},
    mounted() {}
 });


 const exampleCourse = new Vue({
    el: "#example-course",
    components: {OperationComponent, fraction: FractionComponent, FractionComponent, GoogleAutoAd, LongMultiplication, BoxMultiplication},
    data: {},
    mounted() {}
 });

const LessonSummaryVue = new Vue({
   el: '#lesson-summary-block',
   data: {},
   mounted() {},
   components: { LessonSummaryVue }
});